"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRemoveSegmentationData = void 0;

var _ExperimentContext = require("../context/ExperimentContext");

// eslint-disable-next-line import/prefer-default-export
var useRemoveSegmentationData = function useRemoveSegmentationData() {
  var _useExperimentContext = (0, _ExperimentContext.useExperimentContext)(),
      removeSegmentationData = _useExperimentContext.actions.removeSegmentationData;

  return removeSegmentationData;
};

exports.useRemoveSegmentationData = useRemoveSegmentationData;